"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
const head_1 = __importDefault(require("next/head"));
const react_1 = __importStar(require("react"));
/**
 * A container which renders all child elements into the <HEAD> of rendered HTML.
 *
 * Calling this container multiple times will not create additional <HEAD> in the HTML,
 * but instead, all children will be combined and rendered only once into the <HEAD>.
 *
 * There are two ways to de-duplicate or override head tags:
 * 1. Declare identical `key` prop for multiple elements, only last declared element with
 *    identical key gets rendered
 * 2. <meta> tags are automatically de-duplicated based on the `name` or `property` value
 */
const Head = ({ children }) => {
    // Inject keys to de-duplicate certain type of head tags.
    // We only need to inject keys, the de-duplication process is done by Next.js,
    // see https://nextjs.org/docs/api-reference/next/head
    const childrenWithKeys = [];
    // Using forEach(), because map() adds pre/suffixes to the keys,
    // see https://stackoverflow.com/questions/47028558/react-cloneelement-inside-react-children-map-is-causing-element-keys-to-change
    react_1.Children.forEach(children, (headTag) => {
        const { type, props } = headTag;
        if (type === 'meta') {
            const id = props.name || props.property;
            if (id) {
                const field = props.name ? 'name' : 'property';
                const headTagWithKey = (0, react_1.cloneElement)(headTag, {
                    key: `${type}-${field}-${id}`,
                });
                childrenWithKeys.push(headTagWithKey);
                return;
            }
        }
        childrenWithKeys.push(headTag);
    });
    return childrenWithKeys.length ? react_1.default.createElement(head_1.default, null, childrenWithKeys) : null;
};
exports.Head = Head;
